function FooterTracker(analytics) {
    'use strict';

    this.analytics = analytics;
    this.$brands = $('.brands');
    this.$sections = this.$brands.find('> li');
    this.sections = {};
}

FooterTracker.prototype = {
    init() {
        if (!this.$sections.length) {
            return this;
        }

        this.initSections()
            .initCheapTyres();
    },

    /**
     * @return {FooterTracker}
     */
    initSections() {
        this.$sections.each(this.initSection.bind(this));
        return this;
    },

    /**
     * @param  {number} index
     * @param  {DOMElement} section
     * @return {null}
     */
    initSection (index, section) {
        var $section = $(section),
            sectionHeader = $section.find('a').text();

        $section.find('a').on('click', this.trackItemClick.bind(this, sectionHeader));
    },

    /**
     * @return {FooterTracker}
     */
    initCheapTyres() {
        $('.cheap-tyres a').on('click', this.trackItemClick.bind(this, 'Cheap Tyres'));
        return this;
    },

    /**
     * @param  {Object} event
     * @return {FooterTracker}
     */
    trackItemClick (header, event) {

        event.preventDefault();
        var $a = $(event.currentTarget),
            text = $.trim($a.text());

        this.analytics.trackWithCallback(
            {
                eventName: 'Footer',
                eventBody: {
                    event_category: 'Select ' + header,
                    event_label: text
                }
            },
            this.redirect.bind(this, $a.attr('href'))
        );

        return this;
    },

    /**
     * @param  {String} url
     */
    redirect(url) {
        window.location = url;
    }
};

export default FooterTracker;